import { render, staticRenderFns } from "./PageFiles.vue?vue&type=template&id=7041013a&"
import script from "./PageFiles.js?vue&type=script&lang=js&"
export * from "./PageFiles.js?vue&type=script&lang=js&"
import style0 from "./PageFiles.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./PageFiles.lang.cs.yaml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild%2Fthemes%2Fbase%2Fcomponents%2Fcontent%2FPageFiles%2FPageFiles.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports